// extracted by mini-css-extract-plugin
export default {"container":"account-button_container__2iLjn","icon":"account-button_icon__335vK"};